import { useState } from 'react';

import { Icon } from '@/components/icon';
import { IconButton } from '@/components/button';
import { ChatUserMessage, ChatMode } from '@/explore/types';
import { isUserQuestionMessage } from '@/core/cell';

import { UserMessageInput } from './user-message-input';

import commonStyles from '../chat-cell.module.scss';

interface UserMessageProps {
  message: ChatUserMessage;
  disabled?: boolean;
  onChange: (message: ChatUserMessage) => void;
}

export const UserMessage = (props: UserMessageProps) => {
  const { message, disabled, onChange } = props;
  const [isEditing, setIsEditing] = useState(false);

  const handleSubmit = (value: string, sources: string[], mode: ChatMode) => {
    setIsEditing(false);

    if (isUserQuestionMessage(message)) {
      return onChange({
        ...message,
        message: value,
        sources,
        research: mode === 'research',
      });
    }

    return onChange({ ...message, message: value });
  };

  return (
    <div className={commonStyles.responseContainer}>
      <div className={commonStyles.avatar}>
        <Icon name="User" size={24} />
      </div>
      <div className={commonStyles.content}>
        <div className={commonStyles.clarificationHeader}>User</div>
        {isEditing ? (
          <UserMessageInput
            initialValue={message.message}
            sources={isUserQuestionMessage(message) ? message.sources : undefined}
            mode={
              isUserQuestionMessage(message) && message.research === true ? 'research' : undefined
            }
            placeholder="Edit question"
            hideSettings
            onSubmit={handleSubmit}
            onCancel={() => setIsEditing(false)}
            primaryActions={(value, sources, mode) => [
              {
                label: 'Send',
                disabled: value.length === 0,
                onClick: () => handleSubmit(value, sources ?? [], mode),
              },
            ]}
            secondaryActions={[
              {
                label: 'Cancel (Esc)',
                onClick: () => setIsEditing(false),
              },
            ]}
            autoFocus
          />
        ) : (
          <div className={commonStyles.response}>
            <button
              type="button"
              className={commonStyles.response}
              disabled={disabled}
              onClick={() => setIsEditing(true)}>
              {message.message}
            </button>
            <IconButton
              icon="Edit2"
              iconSize="small"
              className={commonStyles.responseEditBtn}
              onClick={() => setIsEditing(true)}
            />
          </div>
        )}
      </div>
    </div>
  );
};
